import React from 'react';
import { TESTIMONIALS } from '../constants';
import { ChevronRight } from 'lucide-react';
import RevealOnScroll from './RevealOnScroll';

const Testimonials: React.FC = () => {
  return (
    <section id="reviews" className="py-12 md:py-24 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900">Trusted by Shoppers Worldwide</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, index) => (
            <RevealOnScroll key={t.id} delay={index * 150}>
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg border border-slate-100 relative h-full flex flex-col hover:-translate-y-1 transition-transform duration-300">
                <div className="mb-4 md:mb-6">
                  <p className="text-slate-600 leading-relaxed font-medium text-sm md:text-base">"{t.text}"</p>
                </div>

                <div className="mt-auto flex items-center gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-slate-200 overflow-hidden shrink-0">
                    {/* Placeholder avatar */}
                    <img src={`https://i.pravatar.cc/150?u=${t.id + 10}`} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                    <p className="text-slate-500 text-xs">{t.location}</p>
                  </div>
                  <div className="ml-auto flex">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/768px-Google_%22G%22_logo.svg.png" alt="Google" className="w-4 h-4 mr-2" />
                  </div>
                </div>
              </div>
            </RevealOnScroll>
          ))}
        </div>

        <div className="flex justify-center mt-8 md:mt-12 gap-4">
          <button className="text-brand-600 font-semibold flex items-center gap-2 hover:underline text-sm md:text-base">
            See More Testimonials <ChevronRight size={16} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;